'use client'

import type { LoginFormActionButtonProps } from '@maestro/commerce-blocks/components/login/login.types'

import { useTranslations } from 'next-intl'
import React, { useCallback } from 'react'
import { useFormStatus } from 'react-dom'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'
import { theme } from '@maestro/local/theme'
import { Button } from '@pearlconvert/ui/components/button'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'

export default function LoginFormActionButton({
  type: _type,
}: LoginFormActionButtonProps) {
  const { registerPage, urls } = theme()
  const { isLoyaltyEnabled } = theme().loyalty
  const { pending } = useFormStatus()
  const t = useTranslations('commerce-blocks')
  const { publish } = useEventBusContext()
  const { addOrUpdateHashParam } = useHash()

  const handleClickRegister = useCallback(() => {
    publish(EventType.SLIDE_IN_OPENED, {
      title: isLoyaltyEnabled
        ? t('auth.register.title-loyalty')
        : t('auth.register.title'),
      slideInType: 'register',
      action: 'open',
    })
    addOrUpdateHashParam(registerPage.modalKey)
  }, [
    addOrUpdateHashParam,
    isLoyaltyEnabled,
    publish,
    registerPage.modalKey,
    t,
  ])

  return (
    <Button
      disabled={pending}
      url={!registerPage.isSlidein ? urls.register : undefined}
      onClick={registerPage.isSlidein ? handleClickRegister : undefined}
      type="secondary"
      buttonType="button"
    >
      {isLoyaltyEnabled
        ? t('auth.register.title-loyalty')
        : t('auth.register.title')}
    </Button>
  )
}
